import { Inject, Component } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'profile-user-exists',
  templateUrl: './user-exists.component.html'
})
export class UserExistsComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
